import React from "react";
import Button from "./Button";
import { useStateContext } from "../contexts/ContextProvider";
import { DateTime } from "luxon";
import NavigateBack from "./NavigateBack";

const TransactionsModal = (props) => {
  const { roomId } = props;
  const { handleModal, transactions, balance } = useStateContext();

  const currentTransactions = transactions.filter((x) => x.roomId === roomId);
  // const sortedTransactions = currentTransactions.sort((a, b) =>
  //   a.date < b.date ? 1 : -1
  // );

  const leaseBalance =
    currentTransactions.reduce((sum, item) => {
      return sum + item.amount;
    }, 0) / 100;

  const currentBalance = balance ? balance : leaseBalance;

  return (
    <div
      className="w-screen h-screen fixed top-0 bottom-0 left-0 right-0 bg-white
      overflow-y-scroll overflow-hidden overscroll-none pb-48 mt-20 z-10"
    >
      <NavigateBack
        zIndex="z-20"
        returnText="Back to room"
        modalNavigation={() => {
          handleModal("transactions");
        }}
      />
      {/* <div className="flex justify-center mt-14">Recent Transactions</div> */}
      <div
        className="fixed top-16 left-0 right-0 flex justify-center gap-x-5 
        h-16 bg-white text-xl px-5 mt-14 pt-5"
      >
        <div>Current Balance:</div>
        <div>
          {Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(currentBalance)}
        </div>
      </div>
      <div className=" border-gray-300 border-1 rounded-xl m-5 px-3 pt-3 pb-10 mt-28">
        {currentTransactions.length > 0 ? (
          <ul>
            {currentTransactions.map((item, index) => {
              return (
                <li
                  key={item.id}
                  className="flex justify-between border-gray-300 border-b-1 px-1 py-3 capitalize"
                >
                  <div className="flex">
                    <div>
                      <div
                        className={`flex items-center
                        ${
                          item.type === "payment"
                            ? item.paymentStatus === "complete"
                              ? "text-green-500"
                              : "text-gray-400"
                            : ""
                        }
                      `}
                      >
                        <div
                          className={`mr-2 ${
                            item.type === "bill"
                              ? "text-blue-500 hover:text-blue-700 underline cursor-pointer"
                              : ""
                          }`}
                          onClick={() => {
                            if (item.type === "bill")
                              console.log("Show the bill!");
                          }}
                        >
                          {item.type + ": " + item.name}
                        </div>
                        <div className="text-sm">
                          {item.type === "chore"
                            ? "(" + item.choreStatus + ")"
                            : ""}
                        </div>
                      </div>
                      <div className="flex">
                        <div
                          className={
                            item.type === "payment"
                              ? item.paymentStatus === "complete"
                                ? "text-green-500"
                                : "text-gray-400"
                              : ""
                          }
                        >
                          {DateTime.fromISO(item.createdAt).toFormat(
                            "dd-MMM-yyyy"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="grid justify-items-end">
                    {item.amount && (
                      <>
                        <div
                          className={
                            item.type === "payment"
                              ? item.paymentStatus === "complete"
                                ? "text-green-500"
                                : "text-gray-400"
                              : ""
                          }
                        >
                          {item.type === "payment" ? "(" : ""}
                          {Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(item.amount / 100)}
                          {item.type === "payment" ? ")" : ""}
                        </div>
                        <div
                          className={
                            item.paymentStatus === "complete"
                              ? "text-green-500"
                              : "text-gray-400"
                          }
                        >
                          {item.paymentStatus}
                        </div>
                      </>
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        ) : (
          <div className="flex justify-center text-gray-400 italic mt-5">
            No Current Transactions
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionsModal;
